<template>
  <div class="c-severity-picker" :class="{'c-severity-picker-simple': simple}">
    <template v-for="severity in enumValues(Severity)" :key="severity">
      <CButton :disabled @click="emit('update:modelValue', severity)" :theme="simple ? 'ghost-primary' : 'normal-secondary'"
               :class="{ 'c-severity-picker-button-active': modelValue === severity && !simple}">
        <template v-if="!simple">
          {{ getSeverityLabel(severity) }}
        </template>
        <CSeverity :severity="severity" :inactive="modelValue !== severity" :size="32"/>
      </CButton>
    </template>
  </div>
</template>

<script setup lang="ts">
  import CSeverity from '@/shared/components/CSeverity.vue';
  import CButton from '@/shared/components/buttons/CButton.vue';
  import Severity from '@/shared/constants/Severity';
  import { getSeverityLabel } from '@/shared/utils/labels';
  import { enumValues } from '@/shared/utils/typescript';

  defineProps<{
    modelValue?: Severity | null;
    disabled?: boolean;
    simple?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'update:modelValue', v: Severity): void;
  }>();
</script>

<style lang="scss">
  .c-severity-picker {
    display: flex;
    flex-wrap: wrap;
    gap: .5rem;

    .c-button {
      flex: 1;
    }

    .c-severity {
      margin-left: auto;
    }

    &-button-active {
        background-color: $primary-100;
    }

    &-simple {
      .c-button {
        padding: 0;
        flex: 0;
      }
      .c-severity {
        margin: 0;
      }
    }
  }
</style>
